import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLength = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12.8018 2.80579L17.1348 4.01868C17.4007 4.09313 17.556 4.36898 17.4815 4.63489L16.2686 8.9679C16.1942 9.23381 15.9174 9.38903 15.6514 9.31458C15.3859 9.2399 15.2313 8.9641 15.3057 8.69837L16.1925 5.52649L2.29696 13.3439L5.46785 14.2316C5.73377 14.306 5.88899 14.5828 5.81453 14.8488C5.73985 15.1143 5.46406 15.2689 5.19832 15.1945L0.865315 13.9816C0.599412 13.9071 0.444203 13.6313 0.518635 13.3654L1.73153 9.03235C1.80598 8.76643 2.0828 8.61121 2.34871 8.68567C2.6143 8.76035 2.76882 9.03615 2.69442 9.30188L1.80672 12.4728L15.7022 4.6554L12.5323 3.76868C12.2664 3.69422 12.1112 3.41741 12.1856 3.15149C12.2603 2.88591 12.5361 2.73138 12.8018 2.80579Z",
		fill: "black"
	})
});
export default SvgLength;
